import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetEmployementTypes(isModalOpen, company_id) {
  return useQuery(
    ['get-employement-types', company_id],
    async () => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.EMPLOYEMENT_TYPE, {
          req_company_id: company_id,
        })
      );
      return res.data;
    },
    {
      enabled: isModalOpen,
    }
  );
}
